import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExceptionTrackingService } from '@com-delta-idp/mnx-utils';
import {
  EXCEPTION_CATEGORY_ENUM,
  IExceptionMetadata,
  LoginOAuth,
  OauthAEMConfig
} from '../../models';
import { UtilService } from '../util-service/util-service';

const fileName = 'UtilsService';

@Injectable({
  providedIn: 'root'
})
export class RedirectfulService {
  redirectfulHeader = new HttpHeaders({
    'x-xsrf-header': 'PingFederate',
    rejectUnauthorized: 'false'
  });

  constructor(
    private utils: UtilService,
    private http: HttpClient,
    private exceptionTracking: ExceptionTrackingService
  ) {}

  async loginOAuthRedirectful(
    authConfig: OauthAEMConfig,
    flowId: string
  ): Promise<LoginOAuth> {
    try {
      const loginOAuthRedirectfulUrl = this.utils.getPingServiceUrl(
        authConfig,
        flowId,
        undefined
      ).loginOAuthRedirectfulUrl;

      if (loginOAuthRedirectfulUrl) {
        const data: LoginOAuth = await this.http
          .get<LoginOAuth>(`${loginOAuthRedirectfulUrl}`, {
            headers: this.redirectfulHeader,
            responseType: 'json',
            withCredentials: true
          })
          .toPromise();
        return data;
      } else {
        const errorResponse = {
          errors: [{ code: 'ERROR_MSG_225' }]
        };
        return errorResponse;
      }
    } catch (exception) {
      const exceptionMetadata: IExceptionMetadata = {
        fileName,
        methodName: 'loginOAuthRedirectful',
        exceptionCategory: EXCEPTION_CATEGORY_ENUM.JS_CATCH_BLOCK,
        exceptionMessage: 'Exception caught while calling loginOAuthRedirectful'
      };
      const exceptionStr = exception as string;
      this.exceptionTracking.track(exceptionStr, exceptionMetadata);
      return exception as LoginOAuth;
    }
  }
}
